import { createContext, ReactNode, useContext, useEffect, useState } from 'react'

interface ImpersonationContextType {
	isImpersonating: boolean
	impersonatedUser: string | null
}

const ImpersonationContext = createContext<ImpersonationContextType>({
	isImpersonating: false,
	impersonatedUser: null,
})

export function ImpersonationProvider({ children }: { children: ReactNode }) {
	const [state, setState] = useState<ImpersonationContextType>({
		isImpersonating: false,
		impersonatedUser: null,
	})

	useEffect(() => {
		const urlParams = new URLSearchParams(window.location.search)
		const impersonateParam = urlParams.get('impersonate')

		if (impersonateParam) {
			setState({
				isImpersonating: true,
				impersonatedUser: impersonateParam,
			})

			document.documentElement.style.setProperty('--ImpersonationBanner-height', '48px')

			if (window.analytics) {
				window.analytics.setOptOut(true)
			}

			if (window.dataLayer) {
				window.dataLayer.push({ 'gtm.blocklist': true })
			}
		}

		return () => {
			document.documentElement.style.setProperty('--ImpersonationBanner-height', '0px')

			if (window.analytics) {
				window.analytics.setOptOut(false)
			}
		}
	}, [])

	return <ImpersonationContext.Provider value={state}>{children}</ImpersonationContext.Provider>
}

export const useImpersonation = () => useContext(ImpersonationContext)
